<div #ele class="scan-multiple-options-container">
  @for (order of orders; track order) {
  <div class="option" (click)="onOrderSelect(order)">
    @if (order.splitted) {
    <b> <img src="/assets/icons/split-order.svg" alt="" /> Order-{{ ordersSplitIndices[order.id] }}</b>
    } @else {
    <b>Order {{ order.orderNumber }}</b>
    }
    <h3><pdq-icon icon="navigation"></pdq-icon> {{ order['shipFromAddress']?.storeName }}</h3>
    <h3>{{ order['batchName'] }}</h3>
  </div>
  }
</div>
